let hasAutoOpenedMenuItems = false;

function openMenuItemsWithImages(navDrawer) {
  const menuItemsWithImages = Array.from(
    navDrawer.querySelectorAll(
      ".mobile-menu__item.mobile-menu__item--level-2.mobile-menu__item--has-items",
    ),
  ).filter((item) => item.querySelector(".mobile-nav__sub-sublist.has-images"));

  menuItemsWithImages.forEach((item) => {
    const button = item.querySelector(
      ".mobile-nav__trigger.mobile-nav__trigger--level-2",
    );
    const mobileDropdown = item.querySelector(".mobile-dropdown");

    if (!button || !mobileDropdown) {
      return;
    }

    if (
      button.classList.contains("is-expanded") ||
      mobileDropdown.classList.contains("is-expanded")
    ) {
      return;
    }

    button.classList.add("is-expanded");
    button.ariaExpanded = "true";

    mobileDropdown.classList.add("is-expanded");
    mobileDropdown.ariaExpanded = "true";
    mobileDropdown.style.height = "auto";
  });
}

document.addEventListener("theme:drawer:open", () => {
  if (hasAutoOpenedMenuItems) {
    return;
  }

  const navDrawer = document.getElementById("nav-drawer");

  if (!navDrawer) {
    return;
  }

  requestAnimationFrame(() => {
    if (!navDrawer.classList.contains("is-open")) {
      return;
    }

    openMenuItemsWithImages(navDrawer);
    hasAutoOpenedMenuItems = true;
  });
});
